<template>
    <modal v-model="showModal" @hidden="onHide" size="regular">
        <template slot="header">
            <div>
                <h2 class="display-4 montserrat-bold mt-4 mb-0">Booking Item</h2>
                <!-- <div class="mt--2 heading-small">Secure your account with your password</div> -->
            </div>
        </template>
        <div class="row">
            <div class="col-lg-12">
                <div class="text-xs">Service</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="shopService.name"></h3>
            </div>
            <div class="col-lg-12">
                <div class="text-xs">Experts</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="displayedExperts"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Quantity</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="bookingItem.quantity"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Duration</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="bookingItem.duration"></h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Price per unit</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="pricePerUnit.toFixed(2)"></h3>
            </div>
        </div>
        <hr class="mb-4 mt-4"/>
        <div class="row">
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Voucher Code</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="bookingItem.discount_code"></h3>
            </div>
            <div class="col-lg-8 col-sm-12">
                <div class="text-xs">Voucher Discount</div>
                <h3 v-if="bookingItem.discount_code_type == 'percentage'" class="font-weight-700 text-default text-sm">
                    PHP {{ voucherDiscountAmount.toFixed(2) }} ({{ voucherDiscount.toFixed(2) }}%)
                </h3>
                <h3 v-else class="font-weight-700 text-default text-sm">
                    PHP {{ voucherDiscountAmount.toFixed(2) }}
                </h3>
            </div>
            <div class="col-lg-4 col-sm-12">
                <div class="text-xs">Additional Fees</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="additionalFees.toFixed(2)"></h3>
            </div>
            <div class="col-lg-8 col-sm-12">
                <div class="text-xs">Additional Discounts</div>
                <h3 class="font-weight-700 text-default text-sm" v-text="additionalDiscounts.toFixed(2)"></h3>
            </div>
        </div>
        <form @submit.prevent="save" class="mt-4 row">
            <div class="col-sm-12">
                <form-input type="textarea" placeholder="Type your notes for this service. . ." label="Note" v-model="form.notes" ref="notes"></form-input>
            </div>
            <div class="col-lg-12">
                <button v-if="!isRequesting" type="submit" class="btn btn-warning long float-right">
                    <i class="fa fa-save mr-1"></i> Save
                </button>
                <button v-else disabled class="disabled btn btn-warning long float-right">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                </button>
            </div>
        </form>
    </modal>
</template>
<script>
import { patch, route } from "@utils/network";
import mixins from '@utils/mixins';
import Form from '@models/components/Form';

export default {
    name: 'BookingItemModal',

    computed: {
        shopService() {
            return this.bookingItem.shopService || {};
        },
        hasExperts() {
            return this.bookingItem.experts && this.bookingItem.experts.length > 0;
        },
        displayedExperts() {
            return this.hasExperts
                ? this.bookingItem.experts.map(expert => expert.fullname).join(", ")
                : "No experts assigned";
        },
        pricePerUnit() {
            return parseFloat(this.bookingItem.price_per_unit || 0);
        },
        additionalFees() {
            return parseFloat(this.bookingItem.additional_fees || 0);
        },
        additionalDiscounts() {
            return parseFloat(this.bookingItem.additional_discounts || 0);
        },
        voucherDiscountAmount() {
            const discount = this.bookingItem.discount_code_type == "percentage"
                ? (this.pricePerUnit * parseFloat(this.bookingItem.quantity)) * (this.bookingItem.discount_code_amount * 0.01)
                : this.bookingItem.discount_code_amount;
            return parseFloat(discount || 0);
        },
        voucherDiscount() {
            return parseFloat(this.bookingItem.discount_code_amount || 0);
        },
    },

    data: () => ({
        isRequesting: false,
        showModal: false,
        clearModal: true,
        bookingItem: {},
        form: new Form({
            notes: "",
        })
    }),

    methods: {
        clearFields(includeErrors = true) {
            this.form.reset();

            if (includeErrors) {
                this.$refs.notes.clearError();
            }
        },

        show(bookingItem) {
            this.showModal = true;
            this.bookingItem = {...bookingItem};
            this.form.notes = bookingItem.notes
            this.form.save();
        },

        onHide() {
            this.showModal = false;
            if (this.clearModal) {
                this.clearFields();
            }
        },

        async save() {
            this.clearModal = this.showModal = false;
            if (!(await this.confirm("Are you sure you want to update this data?", "")).value) {
                this.showModal = true;
                return;
            }
            this.isRequesting = this.clearModal = this.showModal = true;
            patch(route("booking-services/:id/notes", {id:this.bookingItem.id}), { data: this.form.getData() })
                .then(response => this.saved(response))
                .catch(error => this.saveFailed(error))
                .finally(() => (this.isRequesting = false));
        },

        saved(response) {
            this.promptSuccess(response.data.message);
            this.onHide();
            this.$emit("updated", response);
        },

        saveFailed(error) {
            this.promptFormErrors(this.$refs, error);
        },
    },

    mixins: [ mixins ],

    mounted() {
    }
}
</script>